import type { GetPromoterMeBindingResponse } from '@nadoutong/contracts';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import { getMyBinding } from './promoter.ts';

/**
 * React Query wrapper for the C-end promoter binding read.
 *
 * Query key conventions:
 *   - `['promoter', 'binding']`    — GET /v1/promoter/me/binding
 *
 * Bind mutations live on `POST /v1/billing/redeem`; that hook
 * invalidates this key along with balance / credits / transactions.
 */

export const PROMOTER_BINDING_QUERY_KEY = ['promoter', 'binding'] as const;

export function usePromoterBinding(options?: {
  readonly enabled?: boolean;
}): UseQueryResult<GetPromoterMeBindingResponse> {
  const { fetchImpl } = useSession();
  return useQuery({
    queryKey: PROMOTER_BINDING_QUERY_KEY,
    queryFn: ({ signal }) => getMyBinding(fetchImpl, signal),
    enabled: options?.enabled ?? true,
  });
}
